export const API_MEDIA_URL = `${window.location.origin}/media/`;
